import '../Settings/Settings.css';
import './Profile.css';

// Mirrors kosmos_app/access.py ACCESS_ROLES — kept here rather than fetched
// from /api/access-control/ (admin-only) since /api/auth/me/ only returns
// each user's own role keys, which every logged-in user can already see.
const ROLE_INFO = {
    administrator: { label: 'Administrator', icon: '🛡️', description: 'Can manage settings and assign access to other users.' },
    developer:     { label: 'Developer',      icon: '💻', description: 'Can open GitHub repository controls from Settings.' },
    data_manager:  { label: 'Data Manager',   icon: '📊', description: 'Can import, export, and edit dashboard source data.' },
    pipeline:      { label: 'Pipeline Dashboard', icon: '📈', description: 'Can open and use the Pipeline Dashboard.' },
    ar:            { label: 'A/R Dashboard',  icon: '💰', description: 'Can open and use the A/R Dashboard.' },
    arr:           { label: 'ARR Dashboard',  icon: '🔁', description: 'Can open and use the ARR Dashboard.' },
};

function Profile({ user }) {
    const displayName = user?.name || user?.username || 'User';
    const email = user?.email || '';
    const initial = displayName.trim().charAt(0).toUpperCase() || 'U';
    const roles = user?.isSuperuser ? Object.keys(ROLE_INFO) : (user?.access || []);

    return (
        <section className="settings-page" aria-labelledby="profile-title">
            <header className="settings-subpage-head">
                <div>
                    <span className="settings-eyebrow">Your account</span>
                    <h1 id="profile-title">Profile</h1>
                </div>
            </header>

            <div className="settings-hub-layout">
                <article className="profile-hero-card">
                    <div className="profile-hero-band" />
                    <div className="profile-hero-avatar-wrap">
                        <span className="profile-hero-avatar">{initial}</span>
                    </div>

                    <div className="profile-hero-body">
                        <h3>{displayName}</h3>
                        {user?.username && <span className="profile-hero-username">@{user.username}</span>}
                        <em className={user?.isSuperuser ? 'active' : 'inactive'}>
                            {user?.isSuperuser ? 'Super Admin' : user?.isStaff ? 'Staff' : 'Member'}
                        </em>

                        <div className="profile-hero-fact">
                            <span className="profile-hero-fact-icon">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/></svg>
                            </span>
                            <span>{email || 'No email on file'}</span>
                        </div>

                        <div className="profile-hero-stats">
                            <span><b>{roles.length}</b><small>{roles.length === 1 ? 'Role' : 'Roles'}</small></span>
                            <span><b>{user?.isStaff ? 'Yes' : 'No'}</b><small>Staff</small></span>
                            <span><b>{user?.isSuperuser ? 'Yes' : 'No'}</b><small>Superuser</small></span>
                        </div>
                    </div>
                </article>

                <article className="settings-panel profile-roles-panel">
                    <div className="settings-panel-heading">
                        <div className="settings-icon settings-icon-access">RL</div>
                        <div>
                            <span className="settings-kicker">Access</span>
                            <h2>Roles &amp; Permissions</h2>
                        </div>
                    </div>
                    <p className="settings-panel-description">Dashboards and admin tools this account can currently open.</p>

                    {roles.length ? (
                        <div className="profile-role-grid">
                            {roles.map(key => {
                                const info = ROLE_INFO[key] || { label: key, icon: '🔑', description: '' };
                                return (
                                    <div className="profile-role-card" key={key}>
                                        <span className="profile-role-icon">{info.icon}</span>
                                        <div>
                                            <strong>{info.label}</strong>
                                            {info.description && <small>{info.description}</small>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <p className="access-empty">No roles assigned yet — contact an administrator.</p>
                    )}
                </article>
            </div>
        </section>
    );
}

export default Profile;
export { Profile };
